/**
 * @prettier
 */
import * as LayoutUtils from "core/components/layout-utils"

const FormComponentsPlugin = () => ({
  components: { ...LayoutUtils },
})

export default FormComponentsPlugin
